import { SharedService } from '../../../../services/shared/shared.service';
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ChangeDetectionStrategy,
} from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { TableGridColumn, TableGridComponent } from '../table-grid.component';

@Component({
  selector: 'ag-table-column-panel',
  templateUrl: './column-panel.component.html',
  styleUrls: ['./column-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class TableColumnPanelComponent implements OnInit {
  @Input() tableGridColumns: TableGridColumn[];
  @Input() placeholder: string;
  @Output() columnsChanged = new EventEmitter<TableGridColumn[]>();

  filteredColumns: TableGridColumn[];
  form: UntypedFormGroup;
  showFilter: boolean;

  private _columns: TableGridColumn[];

  constructor(
    private _fb: UntypedFormBuilder,
    private _sharedService: SharedService,
  ) {}

  ngOnInit(): void {
    this.initializeFilterForm();
    this.createColumns(this.tableGridColumns);
  }

  createColumns(data: TableGridColumn[]) {
    if (!data?.length) {
      return;
    }

    const groupedData = this._sharedService.groupBy(data, 'display');
    const sortedSelected = this._sharedService.sortArray(groupedData.true, 'label');
    const sortedUnselected = this._sharedService.sortArray(groupedData.false, 'label');
    let filteredData;

    if (sortedSelected?.length && sortedUnselected?.length) {
      filteredData = sortedSelected.concat(sortedUnselected);
    } else if (sortedSelected && !sortedUnselected?.length) {
      filteredData = sortedSelected;
    } else {
      filteredData = sortedUnselected;
    }

    this._columns = filteredData.filter(
      (d) => d.value !== TableGridComponent.CHECKBOX && d.value !== TableGridComponent.ACTIONS,
    );
    this.filteredColumns = this._columns;
  }

  sort(array: any) {
    return array.sort((a, b) => {
      return a.value - b.value;
    });
  }

  private initializeFilterForm() {
    this.form = this._fb.group({
      filter: [''],
    });
  }

  toggleFilter(): void {
    this.showFilter = !this.showFilter;
    this.resetList();
    this.clear();
  }

  filter(event: Event) {
    const value = (event.target as HTMLInputElement).value;
    this.filteredColumns = this._columns.filter((column) => {
      return column.label.toLowerCase().includes(value.toLowerCase());
    });
  }

  toggleDisplayedColumn(selectedOption) {
    selectedOption.display = !selectedOption.display;
    this.columnsChanged.emit([...this._columns]);
  }

  clear() {
    this.form.get('filter').setValue('');
    this.resetList();
  }

  resetList() {
    this.filteredColumns = this._columns;
  }
}
